module.exports = __webpack_public_path__ + "static/media/letter_2@3x.372a4b35.png";


//////////////////
// WEBPACK FOOTER
// ./src/icons/letter_2@3x.png
// module id = 582
// module chunks = 0